import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import App from "./App.tsx";
import "./index.css";

// (audit 2026-06-10) — StrictMode kept in development only. In production
// it was double-invoking every useEffect, which on the admin dashboard
// meant 24 cold-load API calls instead of 12, causing a visibly long
// blank/skeleton state on first paint that users were reporting as
// "broken UI" after hard refresh.
const root = createRoot(document.getElementById("root")!);
if (import.meta.env.DEV) {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  root.render(<App />);
}
